import { GET_CATALOG_ACCOUNT_CLASSIFICATION } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    CatalogAccountAuxiliaryClassificationList:[]
}

function CatalogAccountAuxiliaryClassificationRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_CATALOG_ACCOUNT_CLASSIFICATION:
            return {
                ...state,
                    CatalogAccountAuxiliaryClassificationList:action.payload.map(x=>({
                      Id:x.id,
                      catalogAccountId:x.catalogAccountId,
                      account:x.catalogAccount.account,
                      catalogAccount:x.catalogAccount.display,
                      auxiliaryClassificationId:x.auxiliaryClassificationId,
                      auxiliaryClassification:x.auxiliaryClassification.description
                })) 
            }
        default:
           return state
    }  

}

export default CatalogAccountAuxiliaryClassificationRegister;